export type ReconStatus = 'on_track' | 'watch' | 'investigate' | 'over_reported';

export interface RatioEntry {
  itemCode: string;
  connectionsPerUnit: number;
  class: 'primary' | 'capacity' | 'secondary' | 'none';
}

export const defaultRatios: RatioEntry[] = [
  { itemCode: 'PPM-STS',     connectionsPerUnit: 1,      class: 'primary'   },
  { itemCode: 'PPM-3PH',     connectionsPerUnit: 1,      class: 'primary'   },
  { itemCode: 'MTR-BOX-SP',  connectionsPerUnit: 1,      class: 'primary'   },
  { itemCode: 'DT-100KVA',   connectionsPerUnit: 100,    class: 'capacity'  },
  { itemCode: 'DT-315KVA',   connectionsPerUnit: 300,    class: 'capacity'  },
  { itemCode: 'DT-500KVA',   connectionsPerUnit: 450,    class: 'capacity'  },
  { itemCode: 'SVC-DROP',    connectionsPerUnit: 0.05,   class: 'secondary' },
  { itemCode: 'LVC-25MM',    connectionsPerUnit: 0.02,   class: 'secondary' },
  { itemCode: 'LVC-70MM',    connectionsPerUnit: 0.0125, class: 'secondary' },
  { itemCode: 'POL-CON-9M',  connectionsPerUnit: 10,     class: 'secondary' },
  { itemCode: 'POL-STL-11M', connectionsPerUnit: 12,     class: 'secondary' },
];

/** Map from itemCode -> connectionsPerUnit (0 for unknown) */
export const defaultRatioMap: Record<string, number> = Object.fromEntries(
  defaultRatios.map((r) => [r.itemCode, r.connectionsPerUnit])
);

/** Map from itemCode -> class */
export const defaultClassMap: Record<string, RatioEntry['class']> = Object.fromEntries(
  defaultRatios.map((r) => [r.itemCode, r.class])
);

export const defaultBlendWeights = { primary: 0.6, capacity: 0.25, secondary: 0.15 };

export const defaultCommissioningLagDays = 60;

export const onTrackBand = 15;
export const watchBand = 40;
export const overReportedBand = 25;
